import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { listPlans, type Plan } from '@/lib/api/plans';

export default function PricingPage() {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    void listPlans()
      .then(setPlans)
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);
  if (error) return <Alert severity="error">No se pudo cargar el catálogo: {error}</Alert>;
  if (loading)
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  if (!plans.length)
    return <Alert severity="info">No hay planes disponibles en este momento.</Alert>;
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: 3 }}>
      <Typography variant="h3" align="center" gutterBottom>
        Planes
      </Typography>
      <Typography align="center" color="text.secondary" sx={{ mb: 4 }}>
        Elegí el plan que acompaña a tu equipo.
      </Typography>
      <Grid container spacing={2}>
        {plans.map((plan) => (
          <Grid key={plan.code} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h5">{plan.name}</Typography>
                <Typography variant="h4" sx={{ my: 2 }}>
                  {plan.code === 'enterprise'
                    ? 'Consultar'
                    : new Intl.NumberFormat('es-AR', {
                        style: 'currency',
                        currency: plan.currency,
                        maximumFractionDigits: 0,
                      }).format(plan.monthlyPrice / 100)}
                </Typography>
                <Typography color="text.secondary">
                  {plan.agentLimit == null ? 'Límite negociado' : `${plan.agentLimit} computadoras`}
                </Typography>
              </CardContent>
              <CardActions>
                {plan.code === 'enterprise' ? (
                  <Button href="mailto:ventas@remote-assist.local">Contactar ventas</Button>
                ) : (
                  <Button href="/auth">Comenzar</Button>
                )}
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
